import {
  LIST_MCU_PROJECT_SUPPORTING_DOCS_REQUEST,
  LIST_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS,
  LIST_MCU_PROJECT_SUPPORTING_DOCS_FAIL,
  LIST_MCU_PROJECT_SUPPORTING_DOCS_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_SUPPORTING_DOCS_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_SUPPORTING_DOCS_SUMMARY_FAIL,
  CREATE_MCU_PROJECT_SUPPORTING_DOCS_REQUEST,
  CREATE_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS,
  CREATE_MCU_PROJECT_SUPPORTING_DOCS_FAIL,
  DETAIL_MCU_PROJECT_SUPPORTING_DOCS_REQUEST,
  DETAIL_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS,
  DETAIL_MCU_PROJECT_SUPPORTING_DOCS_FAIL,
  UPDATE_MCU_PROJECT_SUPPORTING_DOCS_REQUEST,
  UPDATE_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS,
  UPDATE_MCU_PROJECT_SUPPORTING_DOCS_FAIL,
  DELETE_MCU_PROJECT_SUPPORTING_DOCS_REQUEST,
  DELETE_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS,
  DELETE_MCU_PROJECT_SUPPORTING_DOCS_FAIL,
  RESET_MCU_PROJECT_CRS
} from '../../constants/mcu-project-supporting-docs'

const initialState = {
  loadingSupportingDocs: false,
  loadingPatchDelete: false,
  mcuProjectSupportingDocs: [],
  mcuProjectSupportingDoc: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_SUPPORTING_DOCS_REQUEST:
      return {
        ...state,
        loadingSupportingDocs: true,
        mcuProjectSupportingDocs: []
      }
    case LIST_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS:
      return {
        ...state,
        loadingSupportingDocs: false,
        mcuProjectSupportingDocs: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_SUPPORTING_DOCS_FAIL:
      return {
        ...state,
        loadingSupportingDocs: false,
        error: action.payload,
        mcuProjectSupportingDocs: []
      }
    case LIST_MCU_PROJECT_SUPPORTING_DOCS_SUMMARY_REQUEST:
      return {
        ...state,
        loadingSupportingDocs: true,
        mcuProjectSupportingDocs: []
      }
    case LIST_MCU_PROJECT_SUPPORTING_DOCS_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingSupportingDocs: false,
        mcuProjectSupportingDocs: action.payload
      }
    case LIST_MCU_PROJECT_SUPPORTING_DOCS_SUMMARY_FAIL:
      return { ...state, loadingSupportingDocs: false, error: action.payload }
    case CREATE_MCU_PROJECT_SUPPORTING_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case CREATE_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case CREATE_MCU_PROJECT_SUPPORTING_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case DETAIL_MCU_PROJECT_SUPPORTING_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true, mcuProjectSupportingDoc: {} }
    case DETAIL_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS:
      return {
        ...state,
        loadingPatchDelete: false,
        mcuProjectSupportingDoc: action.payload
      }
    case DETAIL_MCU_PROJECT_SUPPORTING_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case UPDATE_MCU_PROJECT_SUPPORTING_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case UPDATE_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case UPDATE_MCU_PROJECT_SUPPORTING_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case DELETE_MCU_PROJECT_SUPPORTING_DOCS_REQUEST:
      return { ...state, loadingPatchDelete: true }
    case DELETE_MCU_PROJECT_SUPPORTING_DOCS_SUCCESS:
      return { ...state, loadingPatchDelete: false }
    case DELETE_MCU_PROJECT_SUPPORTING_DOCS_FAIL:
      return { ...state, loadingPatchDelete: false, error: action.payload }
    case RESET_MCU_PROJECT_CRS:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default mcuProjectReducer
